var TEST_KEY = '___local_storage_test_key__';
var canAccessLocalStorage = function () {
    try {
        // Check if window is defined
        if (window && 'localStorage' in window) {
            // Set a test key in local storage
            window.localStorage.setItem(TEST_KEY, 'true');
            // Get the test key from local storage
            var item = window.localStorage.getItem(TEST_KEY);
            if (!item)
                return false;
            window.localStorage.removeItem(TEST_KEY);
            return true;
        }
        return false;
    }
    catch (_a) {
        return false;
    }
};
var mockedLocalStorage = {
    __storage: {},
    clear: function () {
        this.__storage = {};
    },
    setItem: function (key, value) {
        this.__storage[key] = value;
    },
    getItem: function (key) {
        return this.__storage[key];
    },
    removeItem: function (key) {
        delete this.__storage[key];
    },
};
export var safeLocalStorage = canAccessLocalStorage()
    ? window.localStorage
    : mockedLocalStorage;
export default safeLocalStorage;
